import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#private-krankenversicherung-und-unterhaltsverpflichtung

    {
        "betragMonatlich": schemaBigDecimal,
        "gehoertZuAntragsteller": "ANTRAGSTELLER_1" | "ANTRAGSTELLER_2"
    }

*/

export const schemaEuropaceUpdatePrivateKrankenversicherung = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    betragMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceUpdatePrivateKrankenversicherung = z.infer<
    typeof schemaEuropaceUpdatePrivateKrankenversicherung
>;
